import {cs}                from "@Common/react/chain-services";
import {scopedState}       from "@Common/react/scoped-state";
import {UseState}          from "@Common/react/use-state";
import {setCurrentToSaved} from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {changeNestedValue} from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";
import {omit}              from "@Common/utils/objects";

export const YardSignLogic = (
    {
        item,
        templateOptions,
        next: rootNext,
    }
) => cs(

    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            item?.selections?.options?.find((o) => o.group === "YARD SIGN OPTIONS")?.dev_key,
            (_) => ({
                saved  : _,
                current: _,
            }),
        ),
        next,
    })],
    ["step1", ({}, next) => rootNext({
        cleanItem: (item) => changeNestedValue(item, ["selections", "options"], (_) => _?.filter((o) =>
            o.group !== "YARD SIGN OPTIONS"
        )),
        next,
    })],
    ({state, step1}) => step1.next(cs(

        ({}, next) => ["mailing", "shipping", "pickup"].includes(step1.method) && next(),


        ["yardSignOptions", (_, next) => next(templateOptions.options.filter((o) => o.group === "YARD SIGN OPTIONS"))],
        ["calSelected", ({yardSignOptions}, next) => next(!state.value.current ? null : (
            yardSignOptions.find((o) => o.dev_key === state.value.current)
        ))],

        ({calSelected, yardSignOptions}) => ({
            // Total price is not used in Xpresso Product Options page, where Yard Sign module is used
            // totalPrice: calSelected ? +calSelected.flatPrice : 0,
            itemEditor: {
                $name: "yard sign",
                prepareSave: (item) => ({
                    newValue: changeNestedValue(item, ["selections", "options"], (_) => !calSelected ? _ : [
                        ..._ ?? [],
                        omit(calSelected, ["distributionFilter"]),
                    ]),
                    onSaved: () => setCurrentToSaved(state),
                }),

                changed: state.value.saved !== state.value.current,
                valid: true,
            },
            ui: yardSignOptions[0] && {
                yardSignOptions,
                calSelected,
                state: scopedState(state, ["current"]),
            },
        }),
    )),
);